const FijiSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111427)">
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 20.0048 20 0.0021875 20 0C31.0456 0 40 8.95437 40 20Z"
        fill="#338AF3"
      />
      <path d="M19.9999 9.56543V16.311L13.0435 9.56543H19.9999Z" fill="#0052B4" />
      <path
        d="M10.4345 19.9989H16.3104L10.4345 12.1729L9.56494 18.2598L10.4345 19.9989Z"
        fill="#0052B4"
      />
      <path
        d="M19.9468 19.9998H20.0003C20.0003 19.9818 20.0003 19.9643 20.0003 19.9463C19.9825 19.9642 19.9647 19.982 19.9468 19.9998Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 10.4348C20 6.91563 20 4.60977 20 0H19.9966C8.9525 0.001875 0 8.95539 0 20H10.4348V14.1241L16.3107 20H19.9466C19.9645 19.9822 19.9823 19.9644 20.0002 19.9465C20.0002 18.5991 20.0002 17.3968 20.0002 16.3108L14.1241 10.4348H20Z"
        fill="#F0F0F0"
      />
      <path
        d="M10.1181 2.6084C6.99004 4.38957 4.38957 6.99004 2.6084 10.1181V19.9997H7.82582V7.82598V7.82582H19.9997C19.9997 6.18027 19.9997 4.61262 19.9997 2.6084H10.1181Z"
        fill="#D80027"
      />
      <path
        d="M20.0002 17.5403L12.8945 10.4346H10.4351V10.4347L20.0001 19.9997H20.0002C20.0002 19.9997 20.0002 18.3039 20.0002 17.5403Z"
        fill="#D80027"
      />
      <path
        d="M22.6084 13.0438V20.0002C22.6084 24.6596 28.6954 26.0873 28.6954 26.0873C28.6954 26.0873 34.7823 24.6596 34.7823 20.0002V13.0438L28.6954 11.3047L22.6084 13.0438Z"
        fill="#F3F3F3"
      />
      <path
        d="M34.7823 13.0432V10.4346H22.6084V13.0432H27.8257V18.2607H22.6084V19.9997V19.9999L27.8257 20V25.82C28.3505 26.0057 28.6954 26.0868 28.6954 26.0868C28.6954 26.0868 29.04 26.0058 29.5648 25.82V19.9999H34.7823V19.9997V18.2607H29.5648V13.0432H34.7823V13.0432Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111427">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default FijiSvg;
